// ========================================
// RAGE 3D - FLOATING PRODUCTS PREMIUM
// Atlantic Blue & Orange Theme
// Version 2.0 - Future-proof & Enhanced
// ========================================

(function() {
  'use strict';

  // Configurazione
  const CONFIG = {
    animationDuration: 300,
    hoverDelay: 100,
    touchFeedbackDuration: 150,
    intersectionThreshold: 0.1
  };

  // Stato globale
  let isTouch = false;
  let observers = [];

  // ========================================
  // INIZIALIZZAZIONE
  // ========================================

  function init() {
    detectTouchDevice();
    setupFloatingProducts();
    setupCollectionButton();
    setupIntersectionObserver();
    setupPerformanceOptimizations();
  }

  // ========================================
  // RILEVAMENTO DISPOSITIVO TOUCH
  // ========================================

  function detectTouchDevice() {
    isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    
    if (isTouch) {
      document.documentElement.classList.add('touch-device');
    }
  }

  // ========================================
  // SETUP PRODOTTI FLUTTUANTI
  // ========================================

  function setupFloatingProducts() {
    const products = document.querySelectorAll('.floating-product');
    
    products.forEach((product, index) => {
      // Click handler con feedback visivo
      product.addEventListener('click', function(e) {
        handleProductClick(this, e);
      });

      // Touch feedback per mobile
      if (isTouch) {
        setupTouchFeedback(product);
      }

      // Hover handlers per desktop
      if (!isTouch) {
        setupHoverEffects(product);
      }

      // Lazy loading per performance
      setupLazyLoading(product);
    });
  }

  // ========================================
  // GESTIONE CLICK PRODOTTO
  // ========================================

  function handleProductClick(product, event) {
    // Animazione click
    const card = product.querySelector('.floating-product-card');
    
    if (card) {
      card.style.transform = 'scale(0.95)';
      
      setTimeout(() => {
        card.style.transform = '';
      }, CONFIG.animationDuration);
    }

    // Analytics tracking (se disponibile)
    if (typeof window.dataLayer !== 'undefined') {
      const productId = product.dataset.productId;
      window.dataLayer.push({
        'event': 'product_click',
        'product_id': productId
      });
    }
  }

  // ========================================
  // TOUCH FEEDBACK
  // ========================================

  function setupTouchFeedback(product) {
    const info = product.querySelector('.floating-product-info');
    let touchTimer;

    product.addEventListener('touchstart', function(e) {
      // Mostra info al touch
      if (info) {
        info.style.opacity = '1';
        info.style.visibility = 'visible';
        info.style.transform = 'translateY(0)';
      }

      // Feedback visivo
      this.style.transform = 'scale(0.98)';
    }, { passive: true });

    product.addEventListener('touchend', function(e) {
      // Ripristina stato
      this.style.transform = '';

      // Nascondi info dopo delay
      touchTimer = setTimeout(() => {
        if (info) {
          info.style.opacity = '0';
          info.style.visibility = 'hidden';
          info.style.transform = 'translateY(10px)';
        }
      }, 2000);
    }, { passive: true });

    product.addEventListener('touchcancel', function() {
      this.style.transform = '';
      clearTimeout(touchTimer);
    }, { passive: true });
  }

  // ========================================
  // EFFETTI HOVER DESKTOP
  // ========================================

  function setupHoverEffects(product) {
    let hoverTimer;

    product.addEventListener('mouseenter', function() {
      // Pausa animazione float
      this.style.animationPlayState = 'paused';

      // Delay per evitare hover accidentali
      hoverTimer = setTimeout(() => {
        this.classList.add('is-hovered');
      }, CONFIG.hoverDelay);
    });

    product.addEventListener('mouseleave', function() {
      clearTimeout(hoverTimer);
      
      // Riprendi animazione float
      this.style.animationPlayState = 'running';
      this.classList.remove('is-hovered');
    });
  }

  // ========================================
  // LAZY LOADING IMMAGINI
  // ========================================

  function setupLazyLoading(product) {
    const image = product.querySelector('.floating-product-image');
    
    if (!image || !('IntersectionObserver' in window)) {
      return;
    }

    // Se l'immagine ha già src, skip
    if (image.complete && image.naturalHeight !== 0) {
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          loadImage(image);
          observer.unobserve(entry.target);
        }
      });
    }, {
      rootMargin: '50px'
    });

    observer.observe(image);
    observers.push(observer);
  }

  function loadImage(image) {
    if (image.dataset.src) {
      image.src = image.dataset.src;
      image.removeAttribute('data-src');
    }
  }

  // ========================================
  // SETUP BOTTONE COLLEZIONE
  // ========================================

  function setupCollectionButton() {
    const button = document.querySelector('.collection-view-button');
    
    if (!button) return;

    // Click handler con animazione
    button.addEventListener('click', function(e) {
      // Animazione click
      this.style.transform = 'translateY(-2px) scale(0.98)';
      
      setTimeout(() => {
        this.style.transform = '';
      }, CONFIG.animationDuration);
    });

    // Hover effect migliorato
    if (!isTouch) {
      button.addEventListener('mouseenter', function() {
        this.style.transform = 'translateY(-4px) scale(1.02)';
      });

      button.addEventListener('mouseleave', function() {
        this.style.transform = '';
      });
    }

    // Analytics tracking
    button.addEventListener('click', function() {
      if (typeof window.dataLayer !== 'undefined') {
        window.dataLayer.push({
          'event': 'view_collection_click'
        });
      }
    });
  }

  // ========================================
  // INTERSECTION OBSERVER PER ANIMAZIONI
  // ========================================

  function setupIntersectionObserver() {
    const container = document.querySelector('.floating-products-container');
    
    if (!container || !('IntersectionObserver' in window)) {
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          
          // Avvia animazioni prodotti
          const products = entry.target.querySelectorAll('.floating-product');
          products.forEach((product, index) => {
            setTimeout(() => {
              product.style.opacity = '1';
            }, index * 100);
          });
        }
      });
    }, {
      threshold: CONFIG.intersectionThreshold
    });

    observer.observe(container);
    observers.push(observer);
  }

  // ========================================
  // OTTIMIZZAZIONI PERFORMANCE
  // ========================================

  function setupPerformanceOptimizations() {
    // Preconnect a domini esterni se necessario
    preconnectDomains();

    // Prefetch risorse critiche
    prefetchCriticalResources();

    // Cleanup su page unload
    window.addEventListener('beforeunload', cleanup);
  }

  function preconnectDomains() {
    const domains = [
      'https://cdn.shopify.com'
    ];

    domains.forEach(domain => {
      const link = document.createElement('link');
      link.rel = 'preconnect';
      link.href = domain;
      link.crossOrigin = 'anonymous';
      document.head.appendChild(link);
    });
  }

  function prefetchCriticalResources() {
    // Prefetch immagini visibili
    const visibleProducts = document.querySelectorAll('.floating-product');
    
    visibleProducts.forEach((product, index) => {
      if (index < 2) { // Solo i primi 2 prodotti
        const image = product.querySelector('.floating-product-image');
        if (image && image.src) {
          const link = document.createElement('link');
          link.rel = 'prefetch';
          link.as = 'image';
          link.href = image.src;
          document.head.appendChild(link);
        }
      }
    });
  }

  function cleanup() {
    // Disconnetti tutti gli observers
    observers.forEach(observer => {
      if (observer && observer.disconnect) {
        observer.disconnect();
      }
    });
    observers = [];
  }

  // ========================================
  // UTILITY FUNCTIONS
  // ========================================

  // Debounce per eventi frequenti
  function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  // Throttle per scroll events
  function throttle(func, limit) {
    let inThrottle;
    return function(...args) {
      if (!inThrottle) {
        func.apply(this, args);
        inThrottle = true;
        setTimeout(() => inThrottle = false, limit);
      }
    };
  }

  // ========================================
  // GESTIONE RESIZE RESPONSIVO
  // ========================================

  const handleResize = debounce(() => {
    // Ricalcola posizioni se necessario
    const container = document.querySelector('.floating-products-container');
    if (container) {
      container.style.height = ''; // Reset height
      // Il CSS gestirà il resto
    }
  }, 250);

  window.addEventListener('resize', handleResize);

  // ========================================
  // AVVIO QUANDO IL DOM È PRONTO
  // ========================================

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // ========================================
  // ESPORTA FUNZIONI PUBBLICHE (se necessario)
  // ========================================

  window.RageFloatingProducts = {
    refresh: init,
    cleanup: cleanup
  };

})();
